import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import axios from "axios";
import envConfig from "../../bin/env.config";
import { useSelector } from "react-redux";

const MAX_LABEL_LENGTH = 15;

const truncateLabel = (text, maxLength = MAX_LABEL_LENGTH) => {
  if (!text || text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}...`;
};

const useStyles = makeStyles((theme) => ({
  button: {
    maxWidth: 200,
    marginRight: theme.spacing(1),
    justifyContent: "flex-start",
    textTransform: "none",
  },
}));

export default function ProjectDropDownBox({ projectId = 0, onProjectChange }) {
  const classes = useStyles();
  const token = useSelector(state => state.session.token);
  const [anchorEl, setAnchorEl] = useState(null);
  const [listProjects, setListProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/projects?orderBy=name&order=asc&limit=100&skip=0`;
      const result = await axios.post(url, { projectType: "important" }, {
        headers: {
          Authorization: token,
        },
      });
      setListProjects(result.data.data);
    };
    fetchProjects();
  }, [token]);

  const selectedProject = listProjects.find((item) => item.id === projectId);
  const label = projectId === 0 ? "-- All Projects --" : (selectedProject?.name || "-- All Projects --");

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectProject = (id) => {
    setAnchorEl(null);
    onProjectChange(id);
  };

  return (
    <>
      <Button
        color="primary"
        className={classes.button}
        onClick={handleOpenMenu}
        endIcon={<ExpandMoreIcon />}
        title={label}
      >
        {truncateLabel(label)}
      </Button>
      <Menu
        id="project-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem
          selected={projectId === 0}
          onClick={() => handleSelectProject(0)}
        >
          -- All Projects --
        </MenuItem>
        {listProjects.map((item) => (
          <MenuItem
            key={item.id}
            selected={projectId === item.id}
            onClick={() => handleSelectProject(item.id)}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
